import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Router} from "@angular/router";
import {Constants} from "../../constants";
import {environment} from "../../environments/environment";
import {User} from "../../models/user";
import {CompanyDocument} from "../../models/CompanyDocument";
import {response} from "express";

@Injectable({
    providedIn: 'root'
})
export class CompanyDocumentService {

    constructor(private http: HttpClient, private router: Router, @Inject(PLATFORM_ID) private platformId: any) {
    }

    getRequestHeaders() {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem(Constants.LOCAL_TOKEN) ?? environment.publicApiToken
        });
    }

    getFormDataRequestHeaders() {
        return new HttpHeaders({
            'Authorization': localStorage.getItem(Constants.LOCAL_TOKEN) ?? environment.publicApiToken
        });
    }

    getPublicRequestHeaders() {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': environment.publicApiToken,
        });
    }

    async getCompanyDocuments(companyId: string, athleteId: string | undefined) {
        let documents: CompanyDocument[] = [];
        let filter: any = {companyId: companyId, athleteId: athleteId};
        try {
            let response: any = await this.http.get(environment.apiUrl + `/companyDocuments`, {
                headers: this.getRequestHeaders(),
                params: filter,
            }).toPromise()

            if (response.success) {
                documents = [...response.data];
            }

        } catch (e) {
            console.error('error getCompanyDocuments: ', e)
        } finally {
            return documents;
        }
    }

    async getUserCompanyDocuments(companyId: string, userId: string | undefined) {
        let documents: CompanyDocument[] = [];
        let filter: any = {companyId: companyId, userId: userId};
        try {
            let response: any = await this.http.get(environment.apiUrl + `/companyDocuments`, {
                headers: this.getRequestHeaders(),
                params: filter,
            }).toPromise()

            if (response.success) {
                documents = [...response.data];
            }

        } catch (e) {
            console.error('error getCompanyDocuments: ', e)
        } finally {
            return documents;
        }
    }

    async uploadCompanyDocument(formData: FormData, typeOfDocument: string, expirationDate: string | undefined, athleteId: string) {
        let responseUpload: any;
        let urlFile: string = '';

        try {
            responseUpload = await this.http.post(environment.apiUrl + `/companyDocuments/upload`, formData, {
                headers: this.getFormDataRequestHeaders(),
            }).toPromise()

            if (responseUpload.success) {
                urlFile = responseUpload.data;

                let responseSend: any = await this.http.post(environment.apiUrl + `/athleteCompanyDocuments/${athleteId}/send`, {
                    url: urlFile,
                    companyDocumentId: typeOfDocument,
                    expirationDate: expirationDate
                }, {
                    headers: this.getRequestHeaders()
                }).toPromise();

                return responseSend.success;
            } else {
                return false;
            }
        } catch (e) {
            console.error('error uploadCompanyDocument: ', e)
        }
        return false;
    }

    async uploadUserCompanyDocument(formData: FormData, typeOfDocument: string, expirationDate: string | undefined, userId: string) {
        let responseUpload: any;
        let urlFile: string = '';

        try {
            responseUpload = await this.http.post(environment.apiUrl + `/companyDocuments/upload`, formData, {
                headers: this.getFormDataRequestHeaders(),
            }).toPromise()

            if (responseUpload.success) {
                urlFile = responseUpload.data;

                let responseSend: any = await this.http.post(environment.apiUrl + `/userCompanyDocuments/${userId}/send`, {
                    url: urlFile,
                    companyDocumentId: typeOfDocument,
                    expirationDate: expirationDate,
                }, {
                    headers: this.getRequestHeaders()
                }).toPromise();

                return responseSend.success;
            } else {
                return false;
            }
        } catch (e) {
            console.error('error uploadCompanyDocument: ', e)
        }
        return false;
    }

    async updateAthleteCompanyDocument(documentId: string, expirationDate?: string) {
        try {
            const response: any = await this.http.post(
                environment.apiUrl + `/athleteCompanyDocuments/update/${documentId}`,
                {expirationDate: expirationDate},
                {headers: this.getRequestHeaders()}
            ).toPromise();

            return response?.success;
        } catch (e) {
            console.error('error updateAthleteCompanyDocument:', e);
            return false;
        }
    }

    async updateUserCompanyDocument(documentId: string, expirationDate?: string) {
        try {
            const response: any = await this.http.post(
                environment.apiUrl + `/userCompanyDocuments/update/${documentId}`,
                {expirationDate: expirationDate},
                {headers: this.getRequestHeaders()}
            ).toPromise();

            return response?.success;
        } catch (e) {
            console.error('error updateUserCompanyDocument:', e);
            return false;
        }
    }


    async uploadCompanyDocumentModel(document: CompanyDocument, companyId: string) {
        let response: any;

        document['isMandatory'] = parseInt(String(document['isMandatory']));
        document['hasExpirationDate'] = parseInt(String(document['hasExpirationDate']));
        document['companyId'] = companyId;

        try {
            response = await this.http.post(environment.apiUrl + '/companyDocuments', document, {headers: this.getRequestHeaders()}).toPromise();
        } catch (e) {
            console.error('error uploadCompanyDocumentModel: ', e)
        } finally {
            return response;
        }
    }

    async updateCompanyDocumentModel(document: CompanyDocument) {
        let response: any;

        try {
            response = await this.http.put(environment.apiUrl + `/companyDocuments/${document.id}`, document, {headers: this.getRequestHeaders()}).toPromise();
        } catch (e) {
            console.error('error updateCompanyDocumentModel: ', e);
        } finally {
            return response;
        }
    }

    async deleteDocument(documentToDelete: CompanyDocument) {
        let response: any;

        try {
            response = await this.http.delete(environment.apiUrl + `/companyDocuments/${documentToDelete.id}`, {headers: this.getRequestHeaders()}).toPromise();
        } catch (e) {
            console.error('error deleteDocument: ', e);
        } finally {
            return response;
        }
    }

    async uploadModelDocument(formData: FormData) {
        let response: any;
        let urlFile: string = '';
        try {
            response = await this.http.post(environment.apiUrl + '/companyDocuments/upload', formData, {headers: this.getFormDataRequestHeaders()}).toPromise();
        } catch (e) {
            console.error('error uploadCompanyDocumentModel: ', e)
        } finally {
            return response;
        }
    }
}
